module.exports = __webpack_public_path__ + "img/icon.264984b2.png";